<template>
  <el-card id='RoadUnitData' class="box-card">
    <div slot="header" class="clearfix">
      <span>起始桩号:{{roadUnitData.start.stakeval}} - 结束桩号:{{roadUnitData.end.stakeval}}</span>
      <el-button type="info" style="float: right; padding: 1px" icon="el-icon-close" @click=hide circle></el-button>
    </div>
    <div>
      <el-input placeholder="桩号传送门" prefix-icon="el-icon-search" style='width:180px;float:left' v-model="stationNo">
      </el-input>
      <el-button type="success" class='station-btn' icon="el-icon-d-arrow-right" @click=navStation circle></el-button>
      <el-button class='station-btn' icon="el-icon-plus" @click=nextStation circle></el-button>
      <el-button class='station-btn' icon="el-icon-minus" @click=prevStation circle></el-button>
    </div>
    <!--   <el-table
      :data="roadUnitDataTable"
      style="width: 100%">
      <el-table-column
        prop="item"
        label=""
        width="90">
      </el-table-column>
      <el-table-column
        prop="start"
        label="起始桩"
        width="100">
      </el-table-column>
      <el-table-column
        prop="end"
        label="终止桩">
      </el-table-column>
    </el-table> -->
    <div id='selStarttransect' v-if='showTransect'></div>
    <div id='selEndtransect' v-if='showTransect'></div>
    <el-button icon="el-icon-edit" v-if='selectRoadUnit' @click='dialogFormVisible = true'>修改</el-button>
    <el-dialog title="编辑" :visible.sync="dialogFormVisible">
      <el-form ref='modifyRoadDataTable' label-width="80" :model='roadUnitData'>
        <el-row :gutter="20">
          <el-col :span="6">
            <div>&nbsp;</div>
          </el-col>
          <el-col :span="6">
              <div>起始桩号</div>
          </el-col>
          <el-col :span="6">
              <div>终点桩号</div>
          </el-col>
        </el-row>
        <el-row :gutter="20" >
          <el-col :span="6">
            <div>路基左宽</div>
          </el-col>
          <el-col :span="6">
             <el-input v-model.number="roadUnitData.start.leftBaseWidth"></el-input>
          </el-col>
          <el-col :span="6">
              <el-input v-model.number="roadUnitData.end.leftBaseWidth"></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20" >
          <el-col :span="6">
            <div>路基右宽</div>
          </el-col>
          <el-col :span="6">
             <el-input v-model.number="roadUnitData.start.rightBaseWidth"></el-input>
          </el-col>
          <el-col :span="6">
              <el-input v-model.number="roadUnitData.end.rightBaseWidth"></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20" >
          <el-col :span="6">
            <div>路基左高</div>
          </el-col>
          <el-col :span="6">
             <el-input v-model.number="roadUnitData.start.leftBaseHeight"></el-input>
          </el-col>
          <el-col :span="6">
              <el-input v-model.number="roadUnitData.end.leftBaseHeight"></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20" >
          <el-col :span="6">
            <div>路基右高</div>
          </el-col>
          <el-col :span="6">
             <el-input v-model.number="roadUnitData.start.rightBaseHeight"></el-input>
          </el-col>
          <el-col :span="6">
              <el-input v-model.number="roadUnitData.end.rightBaseHeight"></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20" >
          <el-col :span="6">
            <div>左坡脚距</div>
          </el-col>
          <el-col :span="6">
             <el-input v-model.number="roadUnitData.start.leftRootWidth"></el-input>
          </el-col>
          <el-col :span="6">
              <el-input v-model.number="roadUnitData.end.leftRootWidth"></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20" >
          <el-col :span="6">
            <div>右坡脚距</div>
          </el-col>
          <el-col :span="6">
             <el-input v-model.number="roadUnitData.start.rightRootWidth"></el-input>
          </el-col>
          <el-col :span="6">
              <el-input v-model.number="roadUnitData.end.rightRootWidth"></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20" >
          <el-col :span="6">
            <div>左坡脚高</div>
          </el-col>
          <el-col :span="6">
             <el-input v-model.number="roadUnitData.start.leftRootHeight"></el-input>
          </el-col>
          <el-col :span="6">
              <el-input v-model.number="roadUnitData.end.leftRootHeight"></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20" >
          <el-col :span="6">
            <div>右坡脚高</div>
          </el-col>
          <el-col :span="6">
             <el-input v-model.number="roadUnitData.start.rightRootHeight"></el-input>
          </el-col>
          <el-col :span="6">
              <el-input v-model.number="roadUnitData.end.rightRootHeight"></el-input>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeModifyDialog">确 定</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>
<script>
import ViewBasicControls from '@/components/Web3dModels/ViewBasicControls'
export default {
  data: function() {
    return {
      stationNo: '',
      showTransect: true,
      roadUnitData: {
        start: { stakeval: 0 },
        end: { stakeval: 0 }
      },
      roadUnitDataTable: [],
      selectRoadUnit: false,
      dialogFormVisible: false
    }
  },
  methods: {
    hide: function() {
      $("#RoadUnitData").hide();

    },
    navStation: function() {
      this.$emit("selectStation", this.stationNo);
    },
    nextStation: function() {
      this.$emit("nextStation", this.stationNo);
    },
    prevStation: function() {
      this.$emit("prevStation", this.stationNo);
    },
    updateData: function(roadUnitData, webMainView) {
      this.roadUnitData = roadUnitData;
      this.roadUnitData.road.moveToVerticalTransectCenter(this.roadUnitData.start);
      webMainView.$refs.webMap.addMarker(this.roadUnitData.start);
      this.roadUnitData;
      if (roadUnitData != undefined) {
        this.selectRoadUnit = true;
        this.roadUnitDataTable = [];
        this.roadUnitDataTable.push({ item: '路基左宽', start: roadUnitData.start.leftBaseWidth, end: roadUnitData.end.leftBaseWidth });
        this.roadUnitDataTable.push({ item: '路基右宽', start: roadUnitData.start.rightBaseWidth, end: roadUnitData.end.rightBaseWidth });
        this.roadUnitDataTable.push({ item: '路基左高', start: roadUnitData.start.leftBaseHeight, end: roadUnitData.end.leftBaseHeight });
        this.roadUnitDataTable.push({ item: '路基右高', start: roadUnitData.start.rightBaseHeight, end: roadUnitData.end.rightBaseHeight });
        this.roadUnitDataTable.push({ item: '左坡脚距', start: roadUnitData.start.leftRootWidth, end: roadUnitData.end.leftRootWidth });
        this.roadUnitDataTable.push({ item: '右坡脚距', start: roadUnitData.start.rightRootWidth, end: roadUnitData.end.rightRootWidth });
        this.roadUnitDataTable.push({ item: '左坡脚高', start: roadUnitData.start.leftRootHeight, end: roadUnitData.end.leftRootHeight });
        this.roadUnitDataTable.push({ item: '右坡脚高', start: roadUnitData.start.rightRootHeight, end: roadUnitData.end.rightRootHeight });
      }
      if (this.showTransect) {
        $('#selStarttransect').empty();
        $('#selStarttransect').append(roadUnitData.start.drawTransect());
        $('#selEndtransect').empty();
        $('#selEndtransect').append(roadUnitData.end.drawTransect());
        
      }

    },
    closeModifyDialog: function() {

      this.dialogFormVisible = false;
      this.roadUnitData.refreshStationData();
      this.updateData(this.roadUnitData, this.$parent);
    }
  }
}

</script>
<style>
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.box-card {
  width: 320px;
  position: absolute;
  top: 10px;
  right: 10px;
}

.station-btn {
  float: left;
  margin-left: 5px;
  padding: 4px !important;
  ;
  margin-top: 10px;
}

</style>



// WEBPACK FOOTER //
// src/plugins/components/Web3dModels/RoadUnitData.vue